import { render, staticRenderFns } from "./ConfirmArchivePopup.vue?vue&type=template&id=2bce1a0c&scoped=true"
import script from "./ConfirmArchivePopup.vue?vue&type=script&lang=js"
export * from "./ConfirmArchivePopup.vue?vue&type=script&lang=js"
import style0 from "./ConfirmArchivePopup.vue?vue&type=style&index=0&id=2bce1a0c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bce1a0c",
  null
  
)

export default component.exports